<template>
  <div class="w100 card-shadow bg-w">
    <div class="w100 flex-box al-c bor-b pt10 pb10 pl10" style="color: #02a5bd">
      <img class="mr10" :src="`${baseUrl}images/icon-home-app.png`">
      <span class="font-18 mr10" style="color: #02a5bd">应用中心</span>
      <span class="font-14 grey">Application Center</span>
    </div>
    <el-row class="w100 bg-w" v-loading="loading">
      <el-col :span="3" v-for="(item, index) in list" :key="index">
        <a class="block w100 pt20 cu-p tx-c app-item" target="_blank" :href="item.appUrl" @click="serverInsert(item)">
          <img class="app-img" :src="item.appIcon ? item.appIcon : `${baseUrl}images/icon-app.png`" style="width: 60px; height: 60px; border-radius: 50%;">
          <!-- <el-image class="app-img" :src="item.appIcon" lazy style="width: 60px; height: 60px; border-radius: 50%;">
            <img :src="`${baseUrl}images/icon-app.png`" width="60" height="60" slot="error">
          </el-image> -->
          <p class="mt10 pl20 pr20 font-14 ellipsis">{{ item.appName }}</p>
        </a>
      </el-col>
      <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-if="list.length == 0">暂无可用应用</el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "HomeApp",
  components: {},
  props: ["tourist-active"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      list: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.fetchList();
  },
  destroyed() {},
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "/app/appPermitList",
          this.$qs.stringify({
            pageNum: 1,
            pageSize: 100
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    serverInsert(item) {
      this.$http
        .post(
          "/statistical/serverInsert",
          this.$qs.stringify({
            serviceId: item.id,
            appType: 9
          })
        )
        .then(() => {})
        .catch(() => {});
    }
  },
  watch: {
    touristActive() {
      this.fetchList();
    }
  },
  filters: {}
};
</script>

<style scoped>
.app-item {
  height: 140px;
}

.app-item:hover {
  background: #edf5fe;
}
.app-img {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>
